Object.defineProperty(window, 'hulkFBAfterSubmitActionAndAnalytics', {
  value: modifiedHulkFBAfterSubmitActionAndAnalytics,
  writable: false,
  configurable: false,
  enumerable: true,
});


function modifiedHulkFBAfterSubmitActionAndAnalytics(e, t, a) {
    var l = `.hulk_form_${t}`;
    if (window.hulkFormBuilder.plan_features?.shop_plan_features.includes("google-analytics-4-by-measurement-id") || window.hulkFormBuilder.plan_features?.shop_plan_features.includes("google-ads-for-tracking-conversion"))
        var r = e.form_data.event_category
          , i = e.form_data.event_action
          , o = e.form_data.event_label;
    if (window.hulkFormBuilder.plan_features?.shop_plan_features.includes("google-analytics-4-by-measurement-id"))
        var n = e.form_data.event_name;
    if (window.hulkFormBuilder.plan_features?.shop_plan_features.includes("google-analytics-4-by-measurement-id") && e.form_data.google_analytic_4_id && "" !== e.form_data.google_analytic_4_id) {
        var s = window.location !== window.parent.location ? document.referrer : document.location;
        gtag("event", n || "Hulk form builder form submission", {
            eventCategory: r || e.form_data.form_name + " form submission",
            eventAction: i || e.form_data.form_name + " successful form submission",
            eventLabel: o || s
        })
    }
    if (window.hulkFormBuilder.plan_features?.shop_plan_features.includes("google-ads-for-tracking-conversion") && e.form_data.google_tag_conversion_id && "" !== e.form_data.google_tag_conversion_id && e.form_data.google_tag_conversion_label && "" !== e.form_data.google_tag_conversion_label) {
        var s = window.location !== window.parent.location ? document.referrer : document.location;
        gtag("event", "conversion", {
            send_to: "AW-" + e.form_data.google_tag_conversion_id + "/" + e.form_data.google_tag_conversion_label,
            eventCategory: r || e.form_data.form_name + " form submission",
            eventAction: i || e.form_data.form_name + " successful form submission",
            eventLabel: o || s,
            event_callback: function() {
                console.log("Conversion tracked successfully. Parent URL:", s)
            }
        })
    }
    window.hulkFormBuilder.plan_features?.shop_plan_features.includes("facebook-pixel-id") && e.form_data.facebook_pixel_id && "" !== e.form_data.facebook_pixel_id && (window.hulkFormBuilder.shop?.shop_shopify_domain === "benchmade-modern.myshopify.com" ? fbq("trackCustom", "TradeApplication", {
        content_category: e.form_data.form_name + " form submission",
        content_name: "Successful form submission"
    }) : (fbq("track", "Lead", {
        content_category: e.form_data.form_name + " form submission",
        content_name: "Successful form submission"
    }),
    console.log("Standard Lead event triggered for Facebook integration.")));
    let c = 5e3;
    if (e.form_data.form_timer_sec && parseInt(e.form_data.form_timer_sec) > 0 && (c = 1e3 * parseInt(e.form_data.form_timer_sec)),
    "clearAndPrevent" === e.form_data.after_submit) {
        let d = document.querySelector(`${l} .alert_message`);
        (thankYouMessage = hulkFBCustomiseMessage(e.form_data, "thank_you")) && (d.innerHTML = "",
        d.innerHTML = `
          <div class="alert alert-success" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
              <p tabindex="0" aria-label="${thankYouMessage}" class="alert-success">${thankYouMessage}</p>
          </div>`,
        d.style.display = "block");
        let u = document.querySelector(`.hulk_form_${t}`);
        setTimeout( () => {
            let e = document.querySelector(`${l} .alert_message .alert`);
            e && (e.remove(),
            d.style.display = "none")
        }
        , c),
        document.querySelector(`${l} #formGeneratorForm`).reset(),
        document.querySelector(`${l} .form_submit_div .btn`).disabled = !0
    } else if ("clearAndAllow" === e.form_data.after_submit) {
        let m = document.querySelector(`${l} #formGeneratorForm`);
        if (m && (m.reset()),
        e.form_data.after_submit_msg && "" != e.form_data.after_submit_msg.to_s) {
            let p = document.querySelector(`${l} .alert_message`);
            p.innerHTML = `
          <div class="alert alert-success" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
              <p tabindex="0" aria-label="${e.form_data.after_submit_msg.replace(/<\/?[^>]+(>|$)/g, "")}" class="alert-success">${e.form_data.after_submit_msg}</p>
          </div>`,
            p.style.display = "block",
            document.querySelector(`${l} .form_submit_div .btn`).disabled = !1
        }
        let f = document.querySelector(`.hulk_form_${t}`);
        setTimeout( () => {
            let e = document.querySelector(`${l} .alert_message .alert`);
            e && (e.remove(),
            alertMessage.style.display = "none")
        }
        , c)
    } else if ("hideAndmessage" === e.form_data.after_submit) {
        let h = document.querySelector(`${l} .formContainer`);
        h && (h.style.display = "none",
        h.innerHTML = "");
        let b = document.querySelector(`${l} .after_form_submit .form_generater_form_div`);
        b && (b.innerHTML = e.form_data.after_submit_msg,
        b.setAttribute("tabindex", "0"),
        b.setAttribute("aria-label", new DOMParser().parseFromString(e.form_data.after_submit_msg, "text/html").body.textContent),
        b.style.display = "block");
        let y = document.querySelector(`${l} .after_form_submit`);
        if (y) {
            y.style.display = "block";
            let g = JSON.parse(a.user_response)
              , v = JSON.stringify(g)
              , x = document.createElement("input");
            x.type = "hidden",
            x.className = "from_res",
            x.value = v,
            y.appendChild(x)
        }
        let S = document.querySelector(`.hulk_form_${t}`);
    } else if ("redirect" === e.form_data.after_submit) {
        if (void 0 !== e.form_data.after_submit_url) {
            var k = e.form_data.after_submit_url;
            if (void 0 !== e.form_data.openinnewtab && "yes" === e.form_data.openinnewtab) {
                if ("" === k)
                    location.reload();
                else {
                    var q = window.open("", "_blank");
                    q ? q.location.href = k : window.top.location.href = k,
                    document.querySelector(`${l} .formContainer`).style.display = "none",
                    document.querySelector(`${l} .formContainer`).innerHTML = "";
                    let $ = document.querySelector(`${l} .after_form_submit .form_generater_form_div`);
                    $ && ($.innerHTML = e.form_data.after_submit_msg,
                    $.setAttribute("tabindex", "0"),
                    $.setAttribute("aria-label", new DOMParser().parseFromString(e.form_data.after_submit_msg, "text/html").body.textContent));
                    let E = document.querySelector(`${l} .after_form_submit`);
                    E && (E.style.display = "block")
                }
            } else
                "" === k ? location.reload() : window.top.location.href = k
        } else
            location.reload()
    } else if ("responses" === e.form_data.after_submit) {
        var w = JSON.parse(a.user_response)
          , A = `
          <style type="text/css">
              ${l} .after_form_submit .form_generater_form_div table {
                  border-collapse: collapse;
                  width: 100%;
                  border: 1px solid #ccc;
                  table-layout: fixed;
              }
              ${l} .after_form_submit .form_generater_form_div tr {
                  border-bottom: 1px solid #ccc;
              }
              ${l} .after_form_submit .form_generater_form_div tr:nth-child(2n) {
                  background: #ededed;
              }
              ${l} .after_form_submit .form_generater_form_div td,
              ${l} .after_form_submit .form_generater_form_div th {
                  padding: 10px;
                  border: 1px solid #ccc;
                  text-align: left;
                  vertical-align: top;
                  word-break: break-word;
              }
              ${l} .after_form_submit .form_generater_form_div .question_content {
                  color: black;
                  font-size: 15px;
                  font-family: Lato, sans-serif;
                  line-height: 26px;
                  letter-spacing: .07rem;
                  text-transform: none;
                  width: 100%;
                  max-width: 100%;
                  overflow-wrap: break-word;
              }
          </style>
        `;
        window.hulkFormBuilder.shop?.shop_shopify_domain !== "al-manaiya-oasis-festival.myshopify.com" && (form_name = e.form_data.form_name,
        A += `
            <div class="response_div" style="float: right !important;">
                <button type="button" style="padding: 4px 15px; border: none; margin-right: 10px;" aria-label="Download PDF" onclick="hulkFBGeneratePdf('${form_name}', '${l}')">
                    <span>Download PDF</span>
                </button>
                <button type="button" style="padding: 4px 15px; border: none;" aria-label="Download CSV" onclick="hulkFBDownload('${form_name}', '${l}')">
                    <span>Download CSV</span>
                </button>
            </div>
        `),
        A += `
        <h3 class="response_heading" style="margin-top: 45px; color: #394263; text-align: center; font-size: 24px; font-weight: 600;"> ${hulkFBCustomiseMessage(e, "your_response")} </h3>
        <div class="content_div">
            <table class="question_content" cellpadding="15" border="1" cellspacing="0" width="100%" border-collapse="collapse" style="margin-top: 10px;">
      `,
        Object.entries(w).forEach( ([t,a]) => {
            if (A += `<tr><td><b>${t}</b></td><td style="word-wrap: break-word; max-width: 300px;">`,
            "string" != typeof a) {
                if ("image" === a.type || "picture_choice" === a.type)
                    "multiple" === a.upload_type ? a.images.forEach(e => {
                        A += `<a href="${e.url}" target="_blank">
                              <img src="${e.url}" alt="${t}" width="150px" height="150px" style="margin-top: 15px;">
                          </a>`,
                        e.description && "" !== e.description.trim() && (A += `<div style="margin-top: 5px;">${e.description}</div>`)
                    }
                    ) : void 0 !== a.url && (A += `<a href="${a.url}" target="_blank">
                              <img src="${a.url}" alt="${t}" width="150px" height="150px" style="margin-top: 15px;">
                          </a>`,
                    a.description && "" !== a.description.trim() && (A += `<div style="margin-top: 5px;">${a.description}</div>`));
                else if ("file" === a.type)
                    "multiple" === a.upload_type ? a.files.forEach(t => {
                        A += `<br/><a href="${t.url}" target="_blank" style="margin-bottom: 10px;">${hulkFBCustomiseMessage(e, "download_file")}</a>`
                    }
                    ) : A += `<a href="${a.url}" target="_blank">${hulkFBCustomiseMessage(e, "download_file")}</a>`;
                else if ("password" === a.type)
                    "" !== a.password_input && (A += "*".repeat(a.password_input.length));
                else if (void 0 !== a.url)
                    A += `<a href="${a.url}" target="_blank">${hulkFBCustomiseMessage(e, "download_file")}</a>`;
                else if ("url" === a.type) {
                    var l;
                    A += `<p style="color: unset;">${(l = a.value).replace(RegExp("(.{35})", "g"), "$1<br/>")}</p>`
                } else
                    Object.values(a).forEach(e => {
                        Object.entries(e).forEach( ([e,t]) => {
                            "" !== t.trim() && (A += `${e}: ${t}</br>`)
                        }
                        )
                    }
                    )
            } else
                A += a.toString();
            A += "</td></tr>"
        }
        ),
        A += "</table></div>";
        let L = document.querySelector(`${l} .formContainer`);
        L && (L.style.display = "none",
        L.innerHTML = "");
        let C = document.querySelector(`${l} .after_form_submit .form_generater_form_div`);
        C && (C.innerHTML = A);
        let T = document.querySelector(`${l} .after_form_submit`);
        T && (T.style.display = "block")
    }
}
